import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { ShortInvoiceModel } from "../models/InvoiceModel";
import { InvoiceService } from "../services/InvoiceService";

export function useInvoiceVM() {
    const invoiceService = new InvoiceService();

    const [invoice, setInvoice] = useState<ShortInvoiceModel | null>(null);
    const [invoices, setInvoices] = useState<ShortInvoiceModel[]>([]);
    const [listHash, setListHash] = useState<number>(0);

    const [loading, setLoading] = useState(false);
    const [showDetail, setShowDetail] = useState(false);

    const getList = () => {
        setLoading(true);
        setInvoices([]);
        setListHash(Utils.getRandomKey());

        const request = invoiceService.getList();

        DataUtils.onRequest(request, onSearchResult);
    }

    const onSearchResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success && result.data) {
            const invoices = result.data as ShortInvoiceModel[];
            setInvoices(invoices);
            setListHash(Utils.getRandomKey());
        }

        setLoading(false);
    }

    const get = (id: string) => {
        setLoading(true);
        setInvoice(null);
        const request = invoiceService.get(id);
        DataUtils.onRequest(request, onGetResult);
    }

    const onGetResult = (result: IDataResult) => {
        const invoice = result.data as ShortInvoiceModel | null | undefined;

        if (invoice != null) {
            setInvoice(invoice);
        }

        setLoading(false);
    }

    return {
        invoice, setInvoice,
        invoices,
        listHash,

        loading, setLoading,
        showDetail, setShowDetail,

        getList,
        get
    }
}